module.exports = __webpack_public_path__ + "css/UNDP.6531f337.css";